// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"12":"cards","93":"list","263":"widget","276":"grid"}[chunkId] || chunkId) + "." + {"12":"c4d67a73","93":"7f1a8ff1","263":"1796541f","276":"23a12ac0","456":"014932bb"}[chunkId] + ".js";
};